import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/login'
import store from '@/store'

//引入其它子路由，记得在前面加上三点...
import baseInfo from './baseInfo'
import user from './user'
import sys from './sys'
import shopconfig from './shopconfig'
import media from './media'
import topic from './topic'
import course from './course'
import headline from './headline'
import finance from './finance'
import msg from './msg'
import integral from './integral'
import marketing from './marketing'
Vue.use(Router)

const router = new Router({
 /*  mode: 'history', */
  routes: [
    {
      path: '/',
      name: 'Index',
      component: () => import('@/views/Index'),
     // redirect: '/baseInfo/home',
      meta: {title: '主页'},
      children: [
        ...baseInfo,
        ...user,
        ...shopconfig,
        ...marketing,
        ...integral,
        ...media,
        ...course,
        ...topic,
        ...headline,
        ...finance,
        ...msg,
        ...sys
    /*     {
          path: 'baseInfo',
          name: 'baseInfo',
          component: () => import('@/views/main'),
          meta: {keepAlive: true, parentPath: 'baseInfo'},
          children: [
            ...baseInfo
          ]
        },
        {
          path: 'wxconfig',
          name: 'wxconfig',
          component: () => import('@/views/main'),
          meta: {keepAlive: true, parentPath: 'wxconfig'},
          children: [
            ...wxconfig
          ]
        } */

      ]
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        anonymous: true
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  store.getters.getUserInfo()
  if (to.matched.length == 0) return next({ path: '/404' });
  //如果对象里hasOwnProperty检查包涵meta属性，并且为anonymous为真，或isLogin为真才可以进行下一页操作
  if ((to.hasOwnProperty('meta') && to.meta.anonymous) || store.getters.isLogin()) {
    return next();
  }
  //query产生一个随机数在 login->home->login执行不了
  next({ path: '/login', query: { redirect: Math.random() } });
})

router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  console.log(error.message);
  console.log(targetPath);
  if (isChunkLoadFailed) {
    window.location.replace(window.location.href);
    //  router.replace(targetPath);
  }
});
export default router;




// WEBPACK FOOTER //
// ./src/router/index.js